import { getSale } from "./getSale";
import { getTaxRate } from "./getTaxRate";

export const calculateTotals = (
	cartItems,
	country,
	shipping = 0,
	promo = 0,
	state = null
) => {
	// Calculate retail price (MSRP)
	const msrp = cartItems.reduce(
		(total, item) =>
			total + item.optionInfo.RETAIL_PRICE * item.optionInfo.quantity,
		0
	);

	const numOfZGItems = cartItems?.reduce(
		(total, item) =>
			total +
			(item.productInfo.Operation === "Zero Gravity"
				? item.optionInfo.quantity
				: 0),
		0
	);

	const adjustedMsrp = country === "USA" ? msrp * 0.75 : msrp;

	// Calculate discount

	const discount = cartItems?.[0]?.productInfo?.Global_Discount;
	const secondaryDiscount = cartItems?.[0]?.productInfo?.Discount || 0;
	const adjustedDiscount =
		country === "USA" ? secondaryDiscount * 0.75 : secondaryDiscount;
	const operationDiscount =
		numOfZGItems > 2 ? numOfZGItems * 150 * (1 - adjustedDiscount) : 0;

	// Calculate per-item prices with discount
	const itemsWithPrices = cartItems.map((item) => {
		const itemMsrp = item.optionInfo.RETAIL_PRICE * item.optionInfo.quantity;
		const adjustedItemMsrp = country === "USA" ? itemMsrp * 0.75 : itemMsrp;
		const discountAmount = adjustedItemMsrp * discount;
		const finalPrice = adjustedItemMsrp - discountAmount;
		const secondDiscount = finalPrice * item.productInfo.Discount;
		const secondDiscountFinalprice = finalPrice - secondDiscount;

		return {
			...item,
			productInfo: {
				...item.productInfo,
				Global_Discount: discount,
				Discount: item.productInfo.Discount,
			},
			optionInfo: {
				...item.optionInfo,
				OUR_PRICE: secondDiscountFinalprice,
				RETAIL_PRICE: adjustedItemMsrp,
			},
		};
	});

	// Calculate our price using the discounted items
	const ourPrice = itemsWithPrices.reduce(
		(total, item) => total + item.optionInfo.OUR_PRICE,
		0
	);
	const discounts = [discount];

	const savings = discount ? adjustedMsrp - ourPrice : 0;
	const taxRate = getTaxRate(state);
	const tax = !state
		? 0
		: taxRate * (ourPrice - promo + shipping - operationDiscount);
	console.log(
		"PRICE",
		ourPrice,
		promo,
		tax,
		shipping,
		itemsWithPrices,
		operationDiscount
	);
	return {
		country: country,
		msrp: adjustedMsrp,
		ourPrice: ourPrice,
		tax: !tax ? 0 : tax.toFixed(2),
		shipping: shipping,
		subTotal: ourPrice - promo + tax + shipping - operationDiscount,
		savings,
		discount: discount,
		discounts: discounts,
		taxRate: taxRate,
		items: itemsWithPrices,
		operationDiscount: operationDiscount, // Added items with their individual prices
		//  and discounts
		displayMsrp: `$${adjustedMsrp.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displayOurPrice: `$${(ourPrice - operationDiscount).toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displaySavings: `$${savings.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displayOperationSavings: `$${operationDiscount.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
	};
};
